import { CustomErrorMessage } from '@src/design-system/error-message';
import { ErrorMessage, Form } from 'formik';
import FileUpload from '@src/design-system/molecules/file-upload';
import { Button } from '@src/design-system/button';
import { DocumentDownload } from 'iconsax-react';
import { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { toast } from 'react-hot-toast';
import type { TUniversityPayload } from '../../services/universities-api';
import { downloadImportTemplate } from '@src/shared/services/download-template';
import { useFormikContext } from 'formik';

const ImportUniversitiesForm = () => {
  const { values, setFieldValue } = useFormikContext<TUniversityPayload>();
  const [isDownloading, setIsDownloading] = useState(false);

  const handleFileUpload = (file: File | null) => {
    setFieldValue('file', file);
  };

  const handleDownloadTemplate = async () => {
    setIsDownloading(true);
    try {
      await downloadImportTemplate(
        'universities/download-import-template/',
        'universities_import_template'
      );
      toast.success('Template downloaded successfully');
    } catch (_) {
      toast.error('Failed to download template. Please try again.');
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <Form className='space-y-4 p-4'>
      <div className='flex flex-col gap-2'>
        <div className='flex items-center justify-between'>
          <label className='text-gray-800 font-medium text-sm'>
            Upload Multiple Universities
          </label>
          <Button
            className='h-fit w-fit py-0.5 px-1'
            variant='ghost'
            onClick={handleDownloadTemplate}
            disabled={isDownloading}
          >
            <span className='text-primary-1000 font-medium text-sm underline -mr-1'>
              DOWNLOAD TEMPLATE
            </span>
            {isDownloading ? (
              <Loader2
                size={16}
                className='animate-spin text-primary-1000 w-4! h-4!'
              />
            ) : (
              <DocumentDownload className='text-primary-1000 w-4! h-4!' />
            )}
          </Button>
        </div>
        <FileUpload
          file={values.import_history as unknown as File}
          name='file'
          onChange={(file) => {
            handleFileUpload(file);
          }}
          allowedFormats='.xlsx, .xls, .xlsm, .csv'
          maxSize='800x400px'
          note='Note: You must download and use our template to import universities.'
        />
        <ErrorMessage
          name='file'
          component={CustomErrorMessage}
        />
      </div>
    </Form>
  );
};

export default ImportUniversitiesForm;
